
<router-outlet (activate)="activated($event)"></router-outlet>
